import { render } from "./NotifyWhenAvailableButton.vue?vue&type=template&id=3057bff9"
import script from "./NotifyWhenAvailableButton.vue?vue&type=script&lang=js"
export * from "./NotifyWhenAvailableButton.vue?vue&type=script&lang=js"

import "./NotifyWhenAvailableButton.vue?vue&type=style&index=0&id=3057bff9&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__